module.exports = __webpack_public_path__ + "img/payment_success_move.e39131d5.png";